import { kZeroWidthSpace } from "../constants";
import { MeasureText } from "./MeasureText";

export function FindCharBreak(theContent, availableSpace, fontString, breakCharRegEx) {
  var priorString = "";
  var cl = theContent.length;
  if (cl == 0) return priorString;

  var strings = theContent.toString().split(breakCharRegEx);
  var n = strings.length;

  var subStr = "";
  var i = 0;
  var done = false;

  while (!done) {
    priorString = subStr;
    if (strings[i].indexOf("\n") > -1) {
      done = true;
      return priorString + strings[i].split("\n")[0] + kZeroWidthSpace;
    }
    var z = subStr.length + strings[i].length;
    if (z >= cl) subStr = subStr.concat(strings[i++]);
    else subStr = subStr.concat(strings[i++], theContent[z]);

    var m = MeasureText(subStr, fontString);
    if (m > availableSpace) done = true;
    else if (i == n) {
      priorString = theContent;
      done = true;
    }
  }

  return priorString;
}
